
import {dropMenu} from '../../styles';

const Heading = ( {children} ) =>
    <div className={dropMenu.header}>
        <h3 className={dropMenu.heading}>{children}</h3>
    </div>;

export default Heading;